module.exports = __webpack_public_path__ + "img/price-bg.c8695bd6.png";